/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PriorityType,
    PriorityTypeFromJSON,
    PriorityTypeFromJSONTyped,
    PriorityTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface PriorityTypeFilterItemOutput
 */
export interface PriorityTypeFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof PriorityTypeFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {PriorityType}
     * @memberof PriorityTypeFilterItemOutput
     */
    value?: PriorityType;
    /**
     * 
     * @type {boolean}
     * @memberof PriorityTypeFilterItemOutput
     */
    isEffective?: boolean;
}

export function PriorityTypeFilterItemOutputFromJSON(json: any): PriorityTypeFilterItemOutput {
    return PriorityTypeFilterItemOutputFromJSONTyped(json, false);
}

export function PriorityTypeFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorityTypeFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : PriorityTypeFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function PriorityTypeFilterItemOutputToJSON(value?: PriorityTypeFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': PriorityTypeToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


